# Backbone models and collections

window.aqnz ?= {}
aqnz.Model ?= {}
aqnz.Collection ?= {}
Model = aqnz.Model
Collection = aqnz.Collection

class Model.Aqnz extends Backbone.Model
  
  # TODO: RESTful PATCH if has id; otherwise POST to create. 
  
  saveField: (spec) ->
    
    {url, field, data, done, async} = spec
    
    @set field.name, field.value
    data["field"] = field.name
    data[field.name] = field.value
    
    unless aqnz.canEdit
      done(ok: false) if done
      return false
    
    id = @get "id"
    
    $.ajax(
      dataType: "json"
      url: url
      type: "post"
      async: async
      data: data
    ).done((data) =>
      console.log "response", data
      Backbone.trigger "fieldSaved", data
      @newDbRecord(field, data) unless id
      data?.ok = true
      done?(data)
    ).error((data) =>
      @saveError data
    )
  
  newDbRecord: (field, data) ->
    # If new record, set attributes excluding field
    f = field.name
    d = data[f]
    delete data[f]
    @set data
    data[f] = d
  
  saveError: (data) ->
    # TODO: detect login before save attempt - go to save screen
    alert "Cannot save your change(s) to the A+ server.\nPlease check your internet connection, or check you are logged in."
    console.log "Save error", data


class Model.Checklist extends Backbone.Model
  
  defaults: ->
    checklistId: null
    updated: null
    sectionCollection: []
    fileCollection: []
    answersPrevYear: {}
    
  initialize: ->
    {sectionCollection} = @attributes

    sectionCollection.setAnswersPrevYear(@get "answersPrevYear")
    
    @listenTo Backbone, "fieldSaved", (data) =>
      @set "updated", data.updatedDateString


class Model.Section extends Backbone.Model
  
  initialize: ->
    # Replace questions with collection
    questions = @get "questions"
    @unset "questions"
    questionCollection = new Collection.Questions questions
    questionCollection.initDependents()
    @set "questionCollection", questionCollection
    
    @set "visible", true
    
    questionCollection.on "changedAnswer", => @trigger "changedAnswer"
    
  answerSummary: ->
    sectionId = @get "section"
    {name, main, iconClass, questionCollection} = @attributes
    {numQuestions, numEnabled, numToAnswer, numAnswered} = questionCollection.answerSummary()
    {sectionId, name, main, iconClass, numQuestions, numEnabled, numToAnswer, numAnswered}
    
  isMain: ->
    {main, questionCollection} = @attributes
    main or questionCollection.length is 0


class Collection.Sections extends Backbone.Collection
  
  model: Model.Section
  
  initialize: (models, options) ->
    {sections} = options
    @reset sections  # Bootstrap - http://backbonejs.org/#FAQ-bootstrap
    
  setAnswers: (answerTable) ->
    # TODO: Create question lookup table?
    for qId, answer of answerTable
      question = @findByQuestionId qId
      question?.get("answerModel").set(answer)  # Sets answer, checklistId, and id (answer id)

  setAnswersPrevYear: (answersPrevYear) ->
    for section in @models
      questionCollection = section.get "questionCollection"
      questionCollection.each (question) =>
        qId = question.get "qId"
        question.set "answerPrevYear", answersPrevYear[qId] ? null
      
  findByQuestionId: (questionId) ->
    for section in @models
      questionCollection = section.get "questionCollection"
      question = questionCollection.findByQuestionId questionId
      return question if question
    null
    
  answerSummary: ->
    summary = []
    for section in @models
      s = section.answerSummary()
      main = s.main or s.numQuestions is 0
      if main
        name = s.name ? s.sectionId
        iconClass = s.iconClass
        sn = {name, iconClass, numToAnswer: 0, numAnswered: 0}
        summary.push sn
      sn.numToAnswer += s.numToAnswer
      sn.numAnswered += s.numAnswered
    summary
      
  showMain: (name=null) ->
    for section in @models
      continue unless section.isMain()
      show = not name or section.get("name") is name
      section.set "visible", show
      
  mainAnswerSummary: -> @answerSummary().filter (s) => s.iconClass


class Model.Question extends Backbone.Model
  
  defaults: ->
    
    # From reset
    checklistId: null
    qId: null
    type: null
    text: null
    level: null
    subqDefault: null
    enable: null
    na: null
    guide: null
    report: null
    notScored: null
    hectaresConsented: null  # For hectares_farmed question

    # Derived
    enabled: true
    dependents: []
    
    # Answer
    answerModel: null
    
    # Answer analysis (industry)
    analysis: null
    
    # Answers from multiple growers - admin only.
    growerAnswers: null
    growerAnswersVisible: false
    
    #reportQuestion: null
    
    # Regions for numeric question
    regions: null

    answerPrevYear: null
  
  answerClasses: ->
    'yes-no': Model.Answer
    text: Model.Answer
    "number-grower": Model.NumberAnswer
    number: Model.RegionalNumberAnswer  # Regional
    file: Model.FileAnswer
    
  growerAnswerClasses: ->
    "yes-no": Collection.YesNoAnswers
  
  initialize: ->
    
    # TODO: alternative: subanswers child of question?
    answer = @get("answer") ? {answer: null}
    @unset "answer"
    answer.question = this  # Connection to question attributes (checklistId, questionId, level, subqDefault)
    
    #hectares = @get "hectaresConsented"
    #answer.answer = hectares.toFixed(2) if hectares and answer.answer is null
    
    type = @get "type"
    
    # Create model instead of answer attribute
    AnswerClass = @answerClasses()[type] ? Model.Answer
    answerModel = new AnswerClass answer
    @set "answerModel", answerModel
    
    answerModel.on "change:answer", =>
      @setDependentsState()
      @trigger "changedAnswer"
    
    @setGrowerAnswers()
    
  setMaster: (collection) ->
    
    enable = @get "enable"
    return unless enable
    
    for qIdMaster, enableWhenValue of enable
      # TODO: Only one loop cycle expected.  Alt: get via keys[0]?
      masterQuestion = collection.findByQuestionId qIdMaster
      if masterQuestion
        masterQuestion.addDependent
          whenValue: enableWhenValue
          question: this
      else
        console.log "***** Master question not found in collection *****"
    
  addDependent: (dependent) ->
    dependents = @get "dependents"
    dependents.push dependent
    @set "dependents", dependents
    
  setDependentsState: ->
    answer = @answer()
    nonzero = @nonzero()
    dependents = @get "dependents"
    for dependent in dependents
      whenValue = dependent.whenValue
      enabled = (answer in whenValue.split(",")) or (whenValue is "nonzero" and nonzero)
      dependent.question.set "enabled", enabled
  
  answer: -> @get("answerModel").get("answer")
  
  reportAnswer: ->
    q = @get "reportQuestion"  # e.g., from previous year
    noQ = typeof q is "undefined"
    differentYear = aqnz.analysisYear isnt aqnz.year
    return q if noQ and differentYear
    return @answer() if noQ
    q?.answer?.answer ? q?.answer
  
  answered: -> @get("answerModel").answered()
    
  nonzero: ->
    answerModel = @get "answerModel"
    not (answerModel.isZero?() ? true)
    
  # TODO: move to answer class?
  answerSummary: ->
    {type, enabled, required} = @attributes
    answer = @answer()
    answered = @answered()
    isFile = type is "file"
    isText = type is "text"
    mustAnswer = required or (enabled and not (isFile or isText))
    yetToAnswer = mustAnswer and not answered
    {type, enabled, answer, answered, mustAnswer, yetToAnswer}
    
  setGrowerAnswers: ->
    answers = @get "growerAnswers"  # From reset
    @unset "growerAnswers"
    return unless answers
    type = @get "type"
    GrowerAnswersClass = @growerAnswerClasses()[type] ? Collection.GrowerAnswers
    growerAnswers = new GrowerAnswersClass(answers)
    growerAnswers.question = this
    @set "growerAnswers", growerAnswers
    #@set "growerAnswersVisible", false
    
  toggleGrowerAnswersVisibility: ->
    @set "growerAnswersVisible", (not @get "growerAnswersVisible")

  answerPrevYear: ->
    @get("answerPrevYear")?.answer

  fileIdsPrevYear: ->
    @get("answerPrevYear")?.file_ids?.split(",") ? []

  fileUsedPrevYear: (fileId) ->
    fileId in @fileIdsPrevYear()


class Collection.Questions extends Backbone.Collection
  
  model: Model.Question
  
  initDependents: ->
    # Note that enables always operate within same section.
    @each (model) => model.setMaster(this)
    @each (model) => model.setDependentsState() unless aqnz.enableAllDependentQuestions
      
  findByQuestionId: (qId) ->
    # Finds first question with question id.  Assumes only one.
    @find (model) -> model.get("qId") is qId
    
  answerSummary: ->
    numQuestions = @length
    numEnabled = 0
    numToAnswer = 0
    numAnswered = 0
    @each (question) =>
      {type, enabled, answer, answered, mustAnswer} = question.answerSummary()
      #isFile = type is "file" # TODO: include file answers?
      return unless enabled
      numEnabled++
      return unless mustAnswer
      #return if isFile
      numToAnswer++
      numAnswered++ if answered
      true
    {numQuestions, numEnabled, numToAnswer, numAnswered}


class Model.Answer extends Model.Aqnz
  
  url: "/grower-checklist/save"
  
  defaults: ->
    question: null
    checklistId: null
    questionId: null
    id: null  # Answer id (database)
    answer: null
    file_ids: null
    notes: null
    
    subquestionCollection: null
    areaSubquestionCollection: null  # Temporary feature to store previous area-level answers
    subquestionsEnabled: false
    
    queueSubanswer: null

    # Files associated with answer
    fileCollection: null
    editFiles: false
  
  initialize: ->
    question = @get "question"
    @set "checklistId", question.get("checklistId")
    @set "questionId", question.get("qId") unless @get("questionId")
    @initSubquestions()
    @set "file_ids", @get("file_ids")
    @set "fileCollection", aqnz.fileCollection
    fileCollection = @get "fileCollection"
    fileCollection?.setAnswer(this)
    @on "change:answer", => @changeAnswerAction()
    
  initSubquestions: ->
    
    question = @get "question"
    level = question.get "level"
    
    return unless level in ["farm", "area"]
    
    options =
      answerModel: this
      growerAnswerId: @get "id"
      subqDefault: question.get "subqDefault"
      subanswers: @get("subanswers") ? []
    
    @unset "subanswers"
    
    @set "subquestionCollection", new Collection.Farms(null, options)
    
    # Temporary - for area-level questions
    if level is "area"
      @set "areaSubquestionCollection", new Collection.Areas(null, options)
  
  changeAnswerAction: ->
    
    # Handle answer="yes": show subquestions (for more than one area/farm) and auto-set subanswer (for single farm)
    
    isYes = @get("answer") is "yes"
    #return unless isYes
    
    question = @get "question"
    isFarmLevel = question.get("level") is "farm"
    subquestionCollection = @get "subquestionCollection"
    numSubquestions = subquestionCollection?.length
    
    if isYes and isFarmLevel and numSubquestions is 1
      # If only one farm, set applies=1 for the single subquestion.
      # But need to wait for answer to be saved, to set grower answer id.
      subquestion = subquestionCollection.models[0]
      subanswer = 1  # not question.get("subqDefault") ?
      subquestion.queueAnswer subanswer
      @set "queueSubanswer", true
    else
      @trigger "answerReady"
    
    showSubquestions = numSubquestions>1
    @set "subquestionsEnabled", isYes and showSubquestions
  
  onChangeSubanswer: (action) ->
    collection = @get "subquestionCollection"
    collection?.onChangeSubanswer(action)
      
  saveAnswer: (answer, done, async=true) ->
    unless aqnz.canTouch
      done(ok: false) if done
      return false
    field = {name: "answer", value: answer}
    {checklistId, questionId} = @attributes
    data = {checklistId, questionId} 
    next = done
    done = (data) =>
      @set "queueSubanswer", false
      @trigger "answerReady"
      @trigger "answerSaved", data
      next?(data)
    @saveField {@url, field, data, done, async}
    true

  hasFileId: (id) ->
    files = @get("file_ids")
    return false unless files
    fileIds = files.split ","  # Assumes answer in this form
    id.toString() in fileIds

  saveNotes: (notes, done, async=true) ->
    unless aqnz.canTouch
      done(ok: false) if done
      return false
    field = {name: "notes", value: notes}
    {checklistId, questionId} = @attributes
    data = {checklistId, questionId}
    @saveField {@url, field, data, done, async}

  saveFiles: (callback) ->
    fileCollection = @get "fileCollection"
    answer = fileCollection.fileIds(this).join ","
    field = {name: "file_ids", value: answer}
    {checklistId, questionId} = @attributes
    data = {checklistId, questionId} 
    done = (data) => console.log("saveFiles done", data)
    async = true
    @saveField {@url, field, data, done, async}
    callback?()
    
  answered: ->
    answer = @get "answer"
    answer? and answer isnt "" #and answer isnt "{}"
    


class Model.NumberAnswer extends Model.Answer
  
  isZero: ->
    answer = @get "answer"
    return false if answer and answer isnt "" and answer isnt "0"


class Model.RegionalNumberAnswer extends Model.Answer
  
  initialize: ->
    super()
    @set "regions", _.map(aqnz.regions, _.clone)
    @setRegionAnswers()
    
  setRegionAnswers: ->
    
    answer = @get "answer"
    return unless answer
    
    try
      answer = JSON.parse answer
      if parseFloat answer  # TODO: string?
        @setRegionAnswer answer
      else
        @setRegionAnswer(a, r) for r, a of answer
    catch e
      console.log "Cannot parse as JSON:", answer
      @setRegionAnswer answer
      
  setRegionAnswer: (answer, regionName=null) ->
    regions = @get "regions"
    unless regionName
      # Set first region to answer; others blank
      regions[0].answer = answer
    else
      # Find region and set its answer
      region.answer = answer for region in regions when region.name is regionName
    
    answer = @json()
    @set "answer", answer
    answer
  
  json: ->
    regions = @get "regions"
    obj = {}
    for region in regions
      answer = region.answer
      obj[region.name] = answer if answer
    # TODO: if empty obj, save null or "" ?
    JSON.stringify obj
    
  isZero: ->
    regions = @get "regions"
    for region in regions
      answer = region.answer
      return false if answer and answer isnt "" and answer isnt "0"
    true
    
  answered: ->
    answer = @get "answer"
    super() and answer isnt "{}"
  
  numRegionsAnswered: ->
    answer = @get "answer"
    return 0 unless answer
    answer = JSON.parse(answer)
    total = 0
    total++ for p, v of answer
    total
  
  total: ->
    answer = @get "answer"
    return 0 unless answer
    answer = JSON.parse(answer)
    total = 0
    total += parseInt(v) for p, v of answer
    total


class Model.FileAnswer extends Model.Answer
    
  hasFileId: (id) ->
    fileIds = @get("answer").split ","  # Assumes answer in this form
    id.toString() in fileIds
    
  saveFiles: ->
    fileCollection = @get "fileCollection"
    answer = fileCollection.fileIds(this).join ","
    @saveAnswer answer  # TODO callback


class Model.Subanswer extends Model.Aqnz
  
  url: "/subanswer/save"
  
  defaults: ->
    growerAnswerId: null
    areaId: null
    farmId: null
    applies: 0
  
  saveAnswer: (applies, done, async=true) ->
    field = {name: "applies", value: applies}
    {growerAnswerId, areaId, farmId, applies} = @attributes
    data = {growerAnswerId, areaId, farmId, applies}
    @saveField {@url, field, data, done, async}


class Model.Subquestion extends Model.Aqnz
  
  defaults: ->
    subanswer: null
    queueSubanswer: null
    # Also: area, region, farm (see subclass)
  
  initialize: ->
    subanswer = new Model.Subanswer
    @set "subanswer", subanswer
  
  getLevelId: ->
    p = @get @level  # @level from subclass.  TODO: better name that "level" ?
    p.id
  
  setAnswer: (a) =>
    @answer().set a
    
  setGrowerAnswerId: (id) ->
    @answer().set "growerAnswerId", id
    
  applies: ->
    # return false unless subanswer
    @answer().get "applies"
  
  saveAnswer: (applies, done, async=true) ->
    @answer().saveAnswer applies, done, async
    
  onChangeAnswer: (action) ->
    @answer().on "change", -> action?(@get "subanswer")
    
  answer: -> @get "subanswer"
  
  queueAnswer: (answer) ->
    # TODO: queue currently handles only 1 item
    @set "queueSubanswer", answer
    
  processQueue: ->
    answer = @get "queueSubanswer"
    return unless answer?
    @trigger "subanswerToChange", {answer}
    @set "queueSubanswer", null


class Collection.Subquestions extends Backbone.Collection
  
  initialize: (models, options) =>
    
    @setSubanswers options
    
    {answerModel} = options
    
    answerModel.on "answerSaved", (data) =>
      # TODO: combine these into single model callback: change id and process queue.
      # Or call from question.
      @setGrowerAnswerId data.id
      @each (model) => model.processQueue()
    
  setSubanswers: (options) ->
    
    # TODO: simpler op for new db record to set subanswers?
        
    {growerAnswerId, subqDefault, subanswers} = options
    
    table = {}
    for subanswer in subanswers
      levelId = subanswer[@subanswerIdName]  # areaId or farmId or null
      table[levelId] = subanswer if levelId
    
    s = {growerAnswerId: growerAnswerId, applies: subqDefault}
    
    @each (model) =>
      id = model.getLevelId()
      s[@subanswerIdName] = id
      model.setAnswer(table[id] ? s)
  
  setGrowerAnswerId: (id) ->
    # This is needed because main answer id (grower id) does not exist until main question answered.
    @each (model) -> model.setGrowerAnswerId id
  
  numApplies: ->
    applies = @filter (model) -> model.applies()
    applies.length
    
  onChangeSubanswer: (action) ->
    @each (model) -> model.onChangeAnswer action


class Model.Area extends Model.Subquestion
  
  level: "area"  # TODO: better name than level


class Collection.Areas extends Collection.Subquestions
  
  model: Model.Area
  subanswerIdName: "areaId"
  
  initialize: (models, options)->
    @reset aqnz.areas
    super models, options


class Model.Farm extends Model.Subquestion
  
  level: "farm"


class Collection.Farms extends Collection.Subquestions
  
  model: Model.Farm
  subanswerIdName: "farmId"
  
  initialize: (models, options) ->
    @reset aqnz.farms
    super models, options


#------------------ Grower answers ------------------#

class Model.GrowerAnswer extends Backbone.Model
  
  defaults:
    question: null
    grower: null
    checklistId: null
    answer: null
  


class Collection.GrowerAnswers extends Backbone.Collection
  
  model: Model.GrowerAnswer
  
  analysis: ->  # Override in subclass


class Collection.YesNoAnswers extends Collection.GrowerAnswers
  
  # All done in PHP now


#------------------ Checklist answer summaries ------------------#

class Model.AnswerSummary extends Backbone.Model
  
  url: "/checklist/answer-summary"
  
  constructor: (@spec={}) ->
    
    {@scheduleOutput, @year} = @spec
    
    @answerTables = []
    @numAnswerTablesToOutput = null
    
    @fetch (data) =>
      {timeToFetch, answerSummary} = data
      {@sections, @answerTables} = answerSummary
      t0 = performance.now()
      @trigger "fetched"
      @schedule() if @scheduleOutput
      t1 = performance.now()
      #console.log "t1-t0", t1-t0
      
  schedule: ->
    @numAnswerTablesToOutput = @answerTables.length
    go = (a, idx) =>
      setTimeout (=> @outputTable(a)), idx
    go(answerTable, idx) for answerTable, idx in @answerTables
    
  outputTable: (answerTable) ->
    @numAnswerTablesToOutput--
    @trigger "output", {answerTable}
    @trigger "outputAll" if @numAnswerTablesToOutput is 0
  
  getSections: (answerTable) ->
    {year, species, checklistId, answerTable} = answerTable
    sections = @sections[year][species]
    sectionCollection = new Collection.Sections null, {sections}
    sectionCollection.setAnswers(answerTable)
    {checklistId, sectionCollection}
    
  progress: (sectionCollection) ->
    sections = sectionCollection.mainAnswerSummary()
    totalAnswered = 0
    totalToAnswer = 0
    for section in sections
      {numAnswered, numToAnswer} = section
      totalAnswered += numAnswered
      totalToAnswer += numToAnswer
    progress = Math.round(100*totalAnswered/totalToAnswer)
  
  fetch: (done) ->
    
    url = @url
    url += "/#{@year}" if @year
    url += "?_" + new Date().getTime()
    
    $.ajax(
      dataType: "json"
      url: url
      type: "get"
    ).done((data) =>
      console.log "response", data
      done?(data)
    ).error((data) =>
      console.log "Checklist load error", data
    )
  


class Model.IndustryChecklistsReport extends Model.Base
  
  # TODO: get these from server
  species: ['GSM', 'OYS', 'SAL']
  regions: ["Northland", "Auckland", "Waikato", "Bay of Plenty", "Marlborough", "Nelson Bays", "Canterbury", "Southland"]
  
  init: ->
    {@industryModel} = @spec
    {@year, @years, @totals} = @industryModel
    
    @initChecklists()
    
  setAnswerSummary: (@answerSummary) ->
    @progress(table) for table in @answerSummary.answerTables
    @trigger "setAnswerSummary"
    
  initChecklists: ->
    @checklists = {}
    @regions.push "total"
    @regions.push "volumeProduced"
    for year in @years
      @checklists[year] = {}
      for species in @species
        @checklists[year][species] = {}
        for region in @regions
          @checklists[year][species][region] =
            completed: 0
            started: 0
            notStarted: 0
  
  progress: (answerTable) ->
    
    {year, species, areas, volumeProduced} = answerTable
    {sectionCollection} = @answerSummary.getSections(answerTable)
    progress = @answerSummary.progress sectionCollection
    
    regions = @getAreaRegions areas
    
    # Some checklists have no regions (old checklists/species)
    return unless regions.length
    regions.push('total')
    
    for region in regions
      checklists = @checklists[year][species][region]
      if progress is 0
        checklists.notStarted++
      else if progress<100
        checklists.started++
      else if progress is 100
        checklists.completed++
        
    checklists = @checklists[year][species].volumeProduced
    if progress is 0
      field = "notStarted"
    else if progress<100
      field = "started"
    else if progress is 100
      field = "completed"
    checklists[field] += volumeProduced
  
  getAreaRegions: (areas) ->
    regions = []
    for area in areas
      region = area.region.name
      regions.push(region) unless region in regions
    regions
    
  production: (species) ->
    @totals.productionPerSpecies[@year][species].total
  

